import React from 'react';

import { Box, Text } from '@rover/kibble/core';

type TextBadgeProps = {
  children: string;
  isTrainerProfileReordering: boolean;
};

/**
 * @deprecated please use [Kibble Badge]({@link https://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/5670667600/Badge}) instead
 */
export const TextBadge: React.FC<TextBadgeProps> = ({ children, isTrainerProfileReordering }) => {
  const boxStyle: React.ComponentProps<typeof Box> = isTrainerProfileReordering
    ? { py: '1x', px: '2x', borderRadius: '4px' }
    : { py: '2x', px: '3x', borderRadius: '8px' };

  const textStyle: Partial<React.ComponentProps<typeof Text>> = isTrainerProfileReordering
    ? { textColor: 'tertiary' }
    : { fontWeight: 'semibold', textColor: 'secondary' };

  return (
    <Box
      background="interactive.disabled"
      sx={{
        whiteSpace: 'nowrap',
      }}
      {...boxStyle}
    >
      <Text size="200" {...textStyle}>
        {children}
      </Text>
    </Box>
  );
};
